import { map } from 'lodash';
import { BEHAVIOR_TRACKING_PROGRAM_SOURCES } from 'src/constants/analytics';
import ProgramsDB from 'src/fb/programs-db';
import { behaviorTrackingAnalytics } from 'src/services/analytics';

export default {
  methods: {
    /**
     * Copy a program to the library by copying and adjusting content as neccessary
     */
    async copyProgramToClient(programIds, clientId, extProgramProps = {}) {
    // Load program from Firebase
      const programsDb = new ProgramsDB();

      const copiedPrograms = await Promise.all(map(programIds, (programId) => {
        const programProps = {
          client: clientId,
          visibility: 'clinic',
          parentFolder: null,
          originalProgramId: programId,
          typesenseDataHash: null,
          ...extProgramProps,
        };

        const targetProps = {
          introductionDate: null,
          masteryDate: null,
          abortedDate: null,
          holdDate: null,
          currentPromptLevel: null,
          progressSettings: null,
        };

        return programsDb.duplicateProgram(programId, programProps, targetProps);
      }));

      copiedPrograms.forEach((program) => behaviorTrackingAnalytics.trackProgramAdded(program, {
        source: BEHAVIOR_TRACKING_PROGRAM_SOURCES.COPIED_FROM_LIBRARY,
      }));

      return copiedPrograms;
    },
  },
};
